import React, { useEffect } from "react";

type props = {
  onResponse: any;
  appid: string;
  scope: string;
  onRender: any;
};

export const GoogleAuth = (props: props): React.JSX.Element => {
  const { onResponse, appid, scope, onRender } = props;
  useEffect(() => {
      const channel = new BroadcastChannel("google-auth-channel");
      channel.onmessage = (event) => {
        const QueryParams = new URLSearchParams(event.data.code);
        const AuthCode: any = QueryParams.get("code");
        onResponse({ code: AuthCode });
      };
      return () => channel.close();
    }, []);
  
    const openNewTab = (): void => {
      const state = encodeURIComponent(`${window.origin}/google/callback`);
      const width = 599;
      const height = 599;
      const left = (window.screen.width - width) / 2;
      const top = (window.screen.height - height) / 2;
      const callBack = `${process.env.REACT_APP_SOCIAL_CALLBACK}/googlecallback`;
      const features = `width=${width},height=${height},left=${left},top=${top},scrollbars=yes,resizable=yes`;
      const googleOAuthURL = `https://accounts.google.com/o/oauth2/auth?client_id=${appid}&response_type=code&scope=${scope}&redirect_uri=${callBack}&state=${state}&access_type=offline&prompt=consent`;
      window.open(googleOAuthURL, "childwindow", features);
    }; 
  
  
  return (
    <>{onRender({ onClick: openNewTab })}</>
  );
};
